import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { DayPicker } from "react-day-picker"

import { cn } from "@/lib/utils"

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  style,
  ...props
}: React.ComponentProps<typeof DayPicker>) {
  const nav_button = {
    height: '28px',
    width: '28px',
    backgroundColor: 'transparent',
    border: 'none',
    padding: '0',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#374151',
    boxShadow: 'none'
  }
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      style={{
        backgroundColor: 'transparent',
        ...style
      }}
      className={className}
      classNames={{
        months: "",
        month: "",
        caption: "",
        caption_label: "",
        nav: "",
        nav_button: "",
        nav_button_previous: "",
        nav_button_next: "",
        table: "",
        head_row: "",
        head_cell: "",
        row: "",
        cell: "",
        day: "",
        day_range_start: "",
        day_range_end: "",
        day_selected: "",
        day_today: "",
        day_outside: "",
        day_disabled: "",
        day_range_middle: "",
        day_hidden: "",
        ...classNames,
      }}
      styles={{
        months: {
          display: 'flex',
          flexDirection: 'column'
        },
        month: {
          display: 'flex',
          flexDirection: 'column'
        },
        caption: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          paddingBottom: '8px'
        },
        caption_label: {
          fontSize: '16px',
          fontWeight: '500'
        },
        nav: {
          display: 'flex',
          alignItems: 'center'
        },
        nav_button,
        nav_button_previous: {
          ...nav_button,
          position: 'absolute',
          left: '0'
        },
        nav_button_next: {
          ...nav_button,
          position: 'absolute',
          right: '0'
        },
        table: {
          width: '100%',
          borderCollapse: 'collapse',
          height: '280px'
        },
        head_row: {
          display: 'flex',
          marginBottom: '4px',
          width: '100%'
        },
        head_cell: {
          color: '#6b7280',
          flex: '1',
          height: '32px',
          fontWeight: '500',
          fontSize: '14px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        },
        row: {
          display: 'flex',
          width: '100%'
        },
        cell: {
          position: 'relative',
          padding: '0',
          textAlign: 'center',
          fontSize: '14px',
          flex: '1',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        day: {
          width: '40px',
          height: '40px',
          padding: '0',
          fontWeight: 'normal',
          backgroundColor: 'transparent',
          border: 'none',
          boxShadow: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          borderRadius: '0',
          textAlign: 'center',
          outline: 'none',
          userSelect: 'none'
        },
        day_selected: {
          backgroundColor: '#3b82f6',
          color: 'white',
          borderRadius: '50%'
        },
        day_today: {
          backgroundColor: 'transparent',
          color: '#3b82f6',
          fontWeight: '600'
        },
        day_outside: {
          color: '#d1d5db'
        },
        day_disabled: {
          color: '#d1d5db',
          cursor: 'not-allowed'
        }
      } as any}
      components={{
        IconLeft: ({ ...props }) => (
          <ChevronLeft style={{ height: '16px', width: '16px' }} {...props} />
        ),
        IconRight: ({ ...props }) => (
          <ChevronRight style={{ height: '16px', width: '16px' }} {...props} />
        ),
      }}
      {...props}
    />
  )
}

export { Calendar }
